// import { authHeader } from './auth-header';
import api from '../api'

import axios from 'axios'

import endpoint from '../endpoint';
import router from '../../router';

class UserService{

   async login(email, password) {

        return await  axios.post(`${endpoint}/auth/login`, {email,password}).then(
            response => {
                // console.log(response);
                
            // if (response.data.access_token) {
                //when the code is valid, that is when a token is sent from the server 
                // localStorage.setItem('ENSPSID', response.data.access_token);
                // localStorage.setItem('user', response.data.data );

                // localStorage.setItem("user", JSON.stringify(response.data.data));


            // }
            return response.data;
        })
    }
   async register(form) {

        return await  axios.post(`${endpoint}/user-register`, form).then(
            response => {
                return response.data;
        })
    }

    async logout() {
        return await api.post('/auth/logout').then(
            response => {
                localStorage.removeItem('user');
                localStorage.removeItem('ENSPSID')
                return response.data
            }
        );
      
    }

    async verify_user(){
        return await  api.get(`${endpoint}/auth/verify_token`,{headers: { 'Content-Type': 'application/json' }}).then(
            response => {
                // store this token and refresh token
            return response.data;
        }).catch(() =>{
            router.push('/login')
        })
    }

    //authenticate this endpoint
    async create_user(formData) {
        return await api.post(`/auth/register`, formData,{headers: { 'Content-Type': 'application/json' }}).then(
            response =>{
                response.data
            }
        )
    }

    async update_user(form) {

        return await api.put(`update-user/${form.id}`, form).then(
            response =>{
                response.data
            }
        )
    }


    async forgot_password(email){
        return await  axios.post(`${endpoint}/auth/sendResetPasswordCode`, {email},{headers: { 'Content-Type': 'application/json' }}).then(
            response => {
    
            // console.log(response.data)
            return response.data;
        })
    }


    async verify_otp(code,email,action){

        return await  axios.post(`${endpoint}/auth/verify-otp`, {otp:code,email:email},{headers: { 'Content-Type': 'application/json' }}).then(
            response => {
                
                //when the code is valid, that is when a token is sent from the server 
                if (action == 'login'){
                    localStorage.setItem('ENSPSID', response.data.access_token);

                }
                // localStorage.setItem('user', response.data.data);
                return response.data;
            },
            
        )
    }

    async reset_password(password){
        let code = localStorage.getItem('enspsid');
        return await  axios.post(`${endpoint}/auth/passwordReset`, {code:code.toString(),password:password},{headers: { 'Content-Type': 'application/json' }}).then(
            response => {
            localStorage.removeItem('enspsid');
            return response.data;
        })
    }
    async change_password(form){
        return await  api.post(`/auth/change-password`, {
            old_password:form.old,
            new_password:form.new
        }).then(
            response => {
            return response.data;
        })
    }

    async get_users(user_type = null) {
        let endpoint = '/users';
    
        // If user_type is provided
        if (user_type) {
            endpoint += `?user_type=${user_type}`;
        }
    
        return await api.get(endpoint).then(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error);
            }
        );
    }
    

    async get_user(id){
        return await api.get(`/user/${id}`,{id}).then(
            response => {
                return response.data
            }
        )
    }

    

    async get_roles(){
        return await api.get('/roles').then(
            response =>{
                return response.data
            }
        )
    }
    async assign_role(data){
        return await api.post(`/assign-role`, data).then(
            response =>{
                return response.data
            }
        )
    }
    async remove_role(data){
        return await api.post(`/user/remove-role`, data).then(
            response =>{
                return response.data
            }
        )
    }

    async add_user_permission(permission){
        return await api.post('/add-permissions',{permission:permission}).then(
            response =>{
                return response.data
            }
        )
    }

    async delete_user_permission(id){
        return await api.post('/delete-permissions',{id:id}).then(
            response =>{
                return response.data
            }
        )
    }
    async get_permissions(){
        return await api.get('/permissions').then(
            response =>{
                return response.data
            }
        )
    }

    async update_user_permissions(permissions, id){
        return await api.post('/update_permissions',{
            permissions: permissions,
            user_id:id
        }).then(
            response =>{
                return response.data
            }
        )
    }
    
    async generate_user_password(id){
        return await api.put(`/user/${id}/regenerate-password`,{
            user_id:id
        }).then(
            response =>{
                return response.data
            }
        )
    }
    

    async getUserStatistics(params = {}) {
        try {
          const response = await api.get('/users-statistics', { params });
          return response.data;
        } catch (error) {
          console.error('Error fetching user statistics:', error);
          throw error;
        }
      }

}

export default new UserService